import Vue from 'vue';

// event bus
export default new Vue();



// WEBPACK FOOTER //
// ./src/store/bus.js